import React from 'react';
import TextInputLabelOptionalBase, {
    ITextInputProps,
} from './text-input-label-optional-base';

const TextInputLabelOptional = ({
    name,
    onChange,
    className,
    maxLength,
    placeholder,
    value,
    title,
    error,
    showError,
    required,
    onBlur,
}: ITextInputProps) => {
    return (
        <TextInputLabelOptionalBase
            type="text"
            name={name}
            className={className}
            onChange={onChange}
            value={value || ''}
            title={title}
            placeholder={placeholder}
            maxLength={maxLength}
            required={required}
            error={error}
            showError={showError}
            onBlur={onBlur}
        />
    );
};

export default TextInputLabelOptional;
